import axios from "axios";
import { v4 as uuidv4 } from "uuid";

export interface FeedbackI {
    id: number;
    category: "general" | "article" | "bug" | "suggestion";
    title: string;
    message: string;
    userDeviceId: string;
    createdAt: Date;
}

const FEEDBACK_API_BASE_URL = "https://portfoliom-backend.vercel.app/feedback";

export const sendFeedback = async (feedback: Omit<FeedbackI, "userDeviceId">) => {
    // localStorage'da userDeviceId var mı kontrol et
    let userDeviceId = localStorage.getItem("userDeviceId");
    if (!userDeviceId) {
        userDeviceId = uuidv4();
        // userDeviceId'nin kesinlikle string olduğunu belirtmek için '!' kullandık
        localStorage.setItem("userDeviceId", userDeviceId!);
    }

    const payload: FeedbackI = { ...feedback, userDeviceId: userDeviceId! };

    try {
        const response = await axios.post(FEEDBACK_API_BASE_URL, payload, {
            headers: { "Content-Type": "application/json" },
        });
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error)) {
            console.error("Gönderim hatası:", error.message);
            if (error.response) console.error("Sunucu yanıtı:", error.response.data);
        } else {
            console.error("Bilinmeyen hata:", error);
        }
        throw error;
    }
};
